<script setup lang="ts">
interface Props {
  maxDriverCount: number;
}
defineProps<Props>();
</script>
<template>
  <div class="benchmark-drivers-container bg-white rounded-xl p-6 shadow-sm">
    <!-- Header -->
    <div class="text-center">
      <h2 class="text-xl font-family[Poppins] font-bold text-gray-400">CX Drivers</h2>
    </div>

    <!-- Driver Items (Skeleton) -->
    <div class="space-y-27">
      <div v-for="i in maxDriverCount" :key="i" class="driver-item mt-23">
        <div class="flex items-center gap-4">
          <div class="flex-1 relative">
            <div class="w-full h-3 bg-gray-200 rounded-full relative"></div>
          </div>
          <div class="text-center">
            <div class="text-4xl font-bold text-gray-400">-</div>
            <div class="text-12px uppercase tracking-wide text-gray-400">BENCHMARK</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
